<div class="inline-flex items-center gap-2" ngbDropdown container="body">
  <span class="font-semibold" i18n>Liczba rekordów na stronie:</span>
  <button type="button" [disabled]="disabled" ngbDropdownToggle class="inline-flex gap-1 px-0 py-1">
    {{ pageSize }}
  </button>
  <ul role="menu" ngbDropdownMenu>
    <li *ngFor="let value of values" class="dropdown-item" role="menuitem" ngbDropdownItem (click)="changeValue(value)">
      {{ value }}
    </li>
  </ul>
</div>
